import React, { useEffect, useState } from "react";
import COLUMN from "./COLUMN";
import { returnElement } from "../../../components/CustomHooks/CustomHooks";
import useRender from "../../../components/CustomHooks/useRender";

const ColumnWrapper = (props) => {
    // console.log("allColumns", props)
    const [renderElem, updatedData, isEqual] = useRender(props?.data);
        if (updatedData && !isEqual) {
          props.data = updatedData;
      }
    console.log("renderElem column", renderElem, props?.data);
    
    const allowPainting = window?.psh_configs?.paintHiddenColumns ?? true;

    const returnDisplayCheck = (children) => {
        if(!props.previewmode || allowPainting || props.data?.style?.["columnVisibility"] !== "false")
            return false;
        const hideControlNeedToPaint = window.hideControlsNeededToPaint ? window.hideControlsNeededToPaint() : [];
        let hideColumn = false;
        if(children && children.length === 1){
           children.map((data,index) => {
                if (data && data.style && (data.style["Visible"] === "false"||data.style["Visible"] === false)) {
                //   setColumnDisplay(false);
                    hideColumn = hideControlNeedToPaint?.includes(data?.id) || hideControlNeedToPaint?.includes(data?.style?.CustomId) || hideControlNeedToPaint?.includes(data?.dataclass) ? false : true;
                }

            })  
        } else if(children && children.length === 0) {
            if(props.data?.style?.["columnVisibility"] !== "false") {
                hideColumn = false;
            }
            else {
                hideColumn = true;
            }
        }else {
            hideColumn= children.every((child)=>{
                if (child && child.style && (child.style["Visible"] === "false"||child.style["Visible"] === false)) {
                   return hideControlNeedToPaint?.includes(child?.id) || hideControlNeedToPaint?.includes(child?.style?.CustomId) || hideControlNeedToPaint?.includes(child?.dataclass) ? false : true;
                }
            })
        }
        return hideColumn;
    }

    const renderComponent = () => {
        // console.log("inside column render",returnDisplayCheck(props.data.children))
        if(props?.data?.children && !returnDisplayCheck(props.data.children))
            return returnElement(
                {
                    isSubformInPage: props?.isSubformInPage || false,
                    containerId: props.containerId,
                    name:"columns",
                    data: props.data.children,
                    elem_type:"COLUMN",
                    key: props.id,
                    control_id: props.id,
                    stepIndex: props?.stepIndex,
                    sheetIndex: props?.sheetIndex,
                    subStepIndex: props?.subStepIndex,
                    sheetElementIndex: props?.data?.sheetElementIndex,
                    previewmode: props.previewmode,
                    frameindex: props.data.frameIndex,
                    elementIndex: props.elementIndex,
                    sheetIndex: props.sheetIndex,
                    sheetElementIndex: props.sheetElementIndex,
                    ReadOnlyStyle: props.ReadOnlyStyle,
                    isSubForm: props?.isSubForm,
                    buttonId: props?.buttonId,
                    sectionStyle:props?.sectionStyle,
                    ...(!props.previewmode &&
                    {dragId:props.data.id})
                },
                props.data.children,
                "ELEMENTS"
              );
    };
    return(
        <COLUMN {...props} renderChild={renderComponent()}/>
    )
} 
export default ColumnWrapper;